var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", [_vm._v("设施运维")]),
              _c("el-breadcrumb-item", [_vm._v("运维管理")]),
              _c("el-breadcrumb-item", [_vm._v("巡检服务")])
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("搜索条件")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "search-container" },
          [
            _c(
              "el-form",
              {
                staticClass: "search-form",
                attrs: {
                  inline: true,
                  model: _vm.searchForm,
                  "label-width": "100px"
                }
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "工单ID" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入工单ID" },
                              model: {
                                value: _vm.searchForm.TicketId,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "TicketId", $$v)
                                },
                                expression: "searchForm.TicketId"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "区域" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { clearable: "", placeholder: "请选择" },
                                model: {
                                  value: _vm.searchForm.CampusName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "CampusName", $$v)
                                  },
                                  expression: "searchForm.CampusName"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: "张家口-怀来瑞北",
                                    value: "张家口-怀来瑞北"
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: "清远-清新",
                                    value: "清远-清新"
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: "清远-清城",
                                    value: "清远-清城"
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: "深圳-滨海腾大",
                                    value: "深圳-滨海腾大"
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: "贵阳-贵安七星",
                                    value: "贵阳-贵安七星"
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: "天津-滨海高新",
                                    value: "天津-滨海高新"
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: "南京-江宁",
                                    value: "南京-江宁"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "计划开始" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "daterange",
                                "range-separator": "-",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: { change: _vm.handleDateChange },
                              model: {
                                value: _vm.searchForm.createTime,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "createTime", $$v)
                                },
                                expression: "searchForm.createTime"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c(
                        "div",
                        { staticClass: "search-button" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSearch }
                            },
                            [_vm._v("点击查询")]
                          ),
                          _c("el-button", { on: { click: _vm.handleReset } }, [
                            _vm._v("重置")
                          ]),
                          _c(
                            "el-button",
                            { on: { click: _vm.debouncedExport } },
                            [_vm._v(_vm._s(_vm.exportButtonText))]
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "el-tabs",
        {
          staticClass: "custom-tabs",
          on: { "tab-click": _vm.handleTabChange },
          model: {
            value: _vm.activeTab,
            callback: function($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "数据分析", name: "analysis" } },
            [
              _c("div", { staticClass: "title-en" }, [_vm._v("数据分析")]),
              _c("el-card", { staticClass: "box-card" }, [
                _c(
                  "div",
                  { staticClass: "analysis-container" },
                  [
                    _c("ManpowerAnalysis", {
                      attrs: { tableData: _vm.tableDataAll }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "巡检服务列表", name: "list" } },
            [
              _c("div", { staticClass: "title-en" }, [_vm._v("巡检服务列表")]),
              _c("el-card", { staticClass: "box-card" }, [
                _c(
                  "div",
                  { staticClass: "table-container" },
                  [
                    _c(
                      "div",
                      { staticClass: "button-container" },
                      [
                        _c(
                          "el-button",
                          { on: { click: _vm.openColumnsDialog } },
                          [_vm._v("表头设置")]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading"
                          }
                        ],
                        ref: "table",
                        attrs: { data: _vm.tableData, border: "", stripe: "" },
                        on: { "selection-change": _vm.handleSelectionChange }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            type: "selection",
                            width: "55",
                            align: "center"
                          }
                        }),
                        _c("el-table-column", {
                          attrs: {
                            type: "index",
                            label: "序号",
                            width: "60",
                            align: "center"
                          }
                        }),
                        _vm._l(_vm.visibleColumns, function(column, index) {
                          return _c("el-table-column", {
                            key: index,
                            attrs: {
                              prop: column.prop,
                              label: column.label,
                              width: column.width
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      column.prop === "CreateTime" ||
                                      column.prop === "UpdateTime" ||
                                      column.prop === "PlanStartTime" ||
                                      column.prop === "RealStartTime" ||
                                      column.prop === "RealEndTime"
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row[column.prop]
                                                  ? _vm
                                                      .$moment(
                                                        scope.row[column.prop]
                                                      )
                                                      .format("YYYY-MM-DD")
                                                  : "-"
                                              )
                                            )
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row[column.prop] || "-"
                                              )
                                            )
                                          ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        })
                      ],
                      2
                    ),
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          title: "设置显示项",
                          visible: _vm.showColumnsDialog,
                          "append-to-body": true,
                          width: "400px",
                          "close-on-click-modal": false,
                          "custom-class": "columns-dialog",
                          "modal-append-to-body": false,
                          "destroy-on-close": true
                        },
                        on: {
                          "update:visible": function($event) {
                            _vm.showColumnsDialog = $event
                          }
                        }
                      },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            staticClass: "checkbox-group",
                            model: {
                              value: _vm.selectedColumns,
                              callback: function($$v) {
                                _vm.selectedColumns = $$v
                              },
                              expression: "selectedColumns"
                            }
                          },
                          _vm._l(_vm.columns, function(column) {
                            return _c(
                              "el-checkbox",
                              {
                                key: column.prop,
                                staticClass: "checkbox-item",
                                attrs: { label: column.prop }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(column.label) +
                                    "\n              "
                                )
                              ]
                            )
                          }),
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "dialog-footer",
                            attrs: { slot: "footer" },
                            slot: "footer"
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "small" },
                                on: { click: _vm.selectAllColumns }
                              },
                              [_vm._v("全选")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { size: "small" },
                                on: { click: _vm.restoreDefaultColumns }
                              },
                              [_vm._v("恢复默认")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { size: "small", type: "primary" },
                                on: { click: _vm.saveColumnsDialog }
                              },
                              [_vm._v("保存")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "pagination-container" },
                      [
                        _c("el-pagination", {
                          attrs: {
                            "current-page": _vm.currentPage,
                            "page-sizes": [10, 20, 30, 50],
                            "page-size": _vm.pageSize,
                            layout: "total, sizes, prev, pager, next, jumper",
                            total: _vm.total
                          },
                          on: {
                            "size-change": _vm.handleSizeChange,
                            "current-change": _vm.handleCurrentChange
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }